import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'
import { formatDate } from '@/util/formatters'
import { TIPO_DESPESA, TIPO_RECEITA } from '@/enums/payments'
import moment from 'moment/moment'

const state = {
  accountMovement: {},
  accountMovements: {
    data: [],
    count: 0,
    sum: [],
    balance: 0,
    limit: 25,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['id'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }, account) => {
    state.accountMovement = {
      accountId: account.id,
      accountName: account.description,
      date: moment().format('DD/MM/YYYY'),
      type: TIPO_RECEITA,
      companyId: store.get('authStore@currentCompany').id,
    }

    state.filter.startDate = moment().startOf('month').format('DD/MM/YYYY')
    state.filter.endDate = moment().endOf('month').format('DD/MM/YYYY')
    state.filter.accountId = account.id
    state.filter.type = ''

    state.type = 'add'
    state.dialog = true
  },

  save: ({ state, dispatch }, accountMovement) => {
    console.log(accountMovement)
    const id = accountMovement.accountId
    const method = 'post'
    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/accountMovement/`, accountMovement)
      .then((res) => {
        dispatch('get')
        showSuccess('Movimento financeiro salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state, commit }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/accountMovement?${getQueryFromFilter(filter)}`)
      .then(res => {
        commit('accountMovements', res.data)
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/accountMovement/${id}`).catch(showError),

  remove: ({ state }, { id }) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/accountMovement/${id}`)
      .then(_ => {
        store.dispatch('accountMovementStore/get')
        showSuccess('Movimento excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  reloadBalance: ({ state, dispatch }, id) => {
    return axios.post(`${process.env.VUE_APP_API_URL}/accountMovement/${id}`)
      .then(_ => {
        dispatch('get')
        showSuccess('Conta atualizada com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}
const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
